import {
  type FragmentOf,
  graphql,
  readFragment,
  type Timeframe,
} from "@opensea/graphql"
import { VolumeFragment } from "@/components/price/Volume.fragment"

export const StatsVolumeFragment = graphql(
  `
    fragment StatsVolume on Collection {
      stats {
        volume {
          native {
            unit
          }
          ...Volume
        }
        oneMinute {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        fifteenMinute {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        fiveMinute {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        oneDay {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        oneHour {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        sevenDays {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
        thirtyDays {
          volume {
            native {
              unit
            }
            ...Volume
          }
        }
      }
    }
  `,
  [VolumeFragment],
)

type Props = {
  collection: FragmentOf<typeof StatsVolumeFragment>
  timeframe: Timeframe
}

export function useStatsVolume() {
  return ({ collection: collectionKey, timeframe }: Props) => {
    const collection = readFragment(StatsVolumeFragment, collectionKey)
    switch (timeframe) {
      case "ONE_MINUTE":
        return collection.stats.oneMinute.volume
      case "FIVE_MINUTE":
        return collection.stats.fiveMinute.volume
      case "FIFTEEN_MINUTE":
        return collection.stats.fifteenMinute.volume
      case "ALL_TIME":
        return collection.stats.volume
      case "ONE_DAY":
        return collection.stats.oneDay.volume
      case "ONE_HOUR":
        return collection.stats.oneHour.volume
      case "SEVEN_DAYS":
        return collection.stats.sevenDays.volume
      case "THIRTY_DAYS":
        return collection.stats.thirtyDays.volume
      default:
        return collection.stats.volume
    }
  }
}
